import { Cookies } from 'react-cookie';
import getOptimizelyConfig from './getOptimizelyConfig';
import getOptimizelyInstance from './getOptimizelyInstance';
export const forceExperiments = (experiments, userId) => experiments.forEach(exp => {
  const [experiment, variation] = exp.split(':');
  // NOTE: null variation removes the user from a previously forced variation -> https://docs.developers.optimizely.com/full-stack/docs/set-forced-variation-javascript#section-parameters
  const variationToForce = variation || null;

  // NOTE: When clearing a forced variation, only calling setForcedVariation on the server is sufficient.
  // Calling it again on the client afterwards throws Optimizely errors in the console.
  let result;

  // server only code
  if (typeof window === 'undefined' || variationToForce !== null) {
    result = getOptimizelyInstance().setForcedVariation(experiment, userId, variationToForce);
  }
  if (!variationToForce || variationToForce === null) {
    // eslint-disable-next-line no-console
    console.log(`[Optimizely] - successfully removed forced variation for %c${experiment}%c experiment (Resumes normal bucketing)`, 'color: aqua', '');
  } else if (result) {
    // eslint-disable-next-line no-console
    console.log(`[Optimizely] - user forced into %c${experiment}%c experiment under the variation -> %c${variation}`, 'color: aqua', '', 'color: aqua');
  } else {
    // eslint-disable-next-line no-console
    console.log(`[Optimizely] - forcing user into the %c${experiment}%c experiment was %cunsuccessful`, 'color: aqua', '', 'color: red');
  }
});

// parse if json values are present
const parseValue = value => {
  if (value) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }
  return value;
};

// Allows specifying forced variables and their values using the following format:
// If no variable value is specified then we assume a boolean value of true
// feature1!feature2!feature3|variableKey1~variableKey2:variableKey2Value~variableKey3!feature4
export const parseForcedFeatures = forcedFeatureParam => {
  const optimizelyConfig = getOptimizelyConfig();
  return forcedFeatureParam.split(optimizelyConfig.delimiter).reduce((acc, currentFeature) => {
    const featureSplit = currentFeature.split(optimizelyConfig.featureVariableDelimiter);
    const parsedFlag = featureSplit[0].split(optimizelyConfig.variableValueDelimiterRegex);
    if (parsedFlag[1] === 'false') {
      return {
        ...acc,
        [parsedFlag[0]]: false
      };
    }
    let featureVariables = {};
    if (featureSplit[1]) {
      featureVariables = featureSplit[1].split(optimizelyConfig.variableDelimiter).reduce((acc2, currentFeatureVariable) => {
        const currentFeatureVariableSplit = currentFeatureVariable.split(optimizelyConfig.variableValueDelimiterRegex);
        const parsedValue = parseValue(currentFeatureVariableSplit[1]);
        return {
          [currentFeatureVariableSplit[0]]: parsedValue !== undefined ? parsedValue : true,
          ...acc2
        };
      }, {});
    }
    return {
      [parsedFlag[0]]: featureVariables,
      ...acc
    };
  }, {});
};
const forceOptimizelyExperiments = ({
  req = {},
  res = {}
}, userId) => {
  const optimizelyConfig = getOptimizelyConfig();
  let forcedFeatures = {};
  let forcedExperiments = [];
  const cookies = new Cookies(req?.headers?.cookie || null);
  const originalUrl = req.originalUrl || req.url || '';
  // express query string parser is not parsing params with json values properly
  const searchParams = new URLSearchParams(originalUrl.split('?')[1]);
  const optimizelyForcedFeatures = searchParams.get(optimizelyConfig.forceFeatureParam) ?? cookies.get(optimizelyConfig.featCookieName);
  const optimizelyForcedExperiments = searchParams.get(optimizelyConfig.forceExpParam) ?? cookies.get(optimizelyConfig.expCookieName);
  if (optimizelyForcedFeatures) {
    //  set cookie with latest forced feature flags
    if (res.cookie) {
      res.cookie(optimizelyConfig.featCookieName, optimizelyForcedFeatures, optimizelyConfig.cookieOptions);
    }
    forcedFeatures = parseForcedFeatures(optimizelyForcedFeatures);
  } else if (optimizelyForcedFeatures === '') {
    if (res.clearCookie) {
      res.clearCookie(optimizelyConfig.featCookieName, optimizelyConfig.cookieOptions);
    }
    // Resets forcedFeatures in context
    forcedFeatures = {};
  }
  if (optimizelyForcedExperiments) {
    if (res.cookie) {
      res.cookie(optimizelyConfig.expCookieName, optimizelyForcedExperiments, optimizelyConfig.cookieOptions);
    }
    optimizelyForcedExperiments.split(optimizelyConfig.delimiter).filter(Boolean).forEach(exp => {
      forcedExperiments.push(exp);
    });
    forceExperiments(forcedExperiments, userId);
  } else if (optimizelyForcedExperiments === '') {
    if (res.clearCookie) {
      res.clearCookie(optimizelyConfig.expCookieName, optimizelyForcedExperiments, optimizelyConfig.cookieOptions);
    }
    // Resets forcedExperiments in context
    forcedExperiments = [];
  }
  return {
    forcedFeatures,
    forcedExperiments
  };
};
export default forceOptimizelyExperiments;